import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/tableViews')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/tableView' })
  },
})
